<script>
  import { browser } from '$app/environment';
  import RecObjectOpenGraph from '@og/RecObject.svelte';
  import Group from '@pages/Group.svelte';

  export let data;

  let { og, group, sections, recs, recObjects, accessDenied, unknownError, params, searchParams } = data;
  $: ({ og, group, sections, recs, recObjects, accessDenied, unknownError, params, searchParams } = data);

  let detailId = searchParams.get('detail_id');
  let ts = searchParams.get('ts') || 1;
  let slug = params.slug;

  if (browser) {
    window.detailViewLoadedDirectly = true;
  }
</script>

<svelte:head>
  <meta name="robots" content="noindex" />
</svelte:head>
<RecObjectOpenGraph group={og.group} recObject={og.rec_object} />

{#if browser}
  {#key slug}
    {#key detailId}
      {#key ts}
        <Group
          slug={slug}
          params={params}
          group={group}
          sections={sections}
          recs={recs}
          recObjects={recObjects}
          accessDenied={accessDenied}
          unknownError={unknownError}
          detailId={detailId}
          ts={ts} />
      {/key}
    {/key}
  {/key}
{/if}
